<template>
  <div class="coupon-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="操作人">
          <el-input v-model="filterForm.operator" placeholder="操作人" clearable style="width: 140px;" @keyup.enter.native="handleSearch" />
        </el-form-item>
        <el-form-item label="任务状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable style="width: 140px;">
            <el-option label="已完成" :value="1" />
            <el-option label="部分成功" :value="2" />
            <el-option label="失败" :value="3" />
          </el-select>
        </el-form-item>
        <el-form-item label="操作时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 任务表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="logList"
        height="60vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="batch_no" label="批次号" width="230" show-overflow-tooltip />
        <el-table-column prop="template_names" label="券模板" min-width="140" show-overflow-tooltip />
        <el-table-column label="人数/计划张数" width="120" align="center">
          <template slot-scope="scope">
            {{ scope.row.member_total }} / {{ scope.row.plan_total }}
          </template>
        </el-table-column>
        <el-table-column label="成功/失败(张)" width="120" align="center">
          <template slot-scope="scope">
            <span style="color: #67c23a;">{{ scope.row.success_coupon }}</span>
            /
            <span :style="{ color: Number(scope.row.fail_coupon) > 0 ? '#f56c6c' : '#999' }">{{ scope.row.fail_coupon }}</span>
          </template>
        </el-table-column>
        <el-table-column label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="taskStatusTagType(scope.row.status)">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="operator" label="操作人" width="90" align="center" />
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.remark || '-' }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="操作时间" width="160" />
        <el-table-column prop="finish_time" label="完成时间" width="160" />
        <el-table-column label="操作" width="100" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="openDetail(scope.row)">发放明细</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>

    <!-- 任务明细弹窗 -->
    <el-dialog
      :title="'发券明细 - ' + (currentTask.batch_no || '')"
      :visible.sync="detailVisible"
      width="780px"
      @opened="onDetailOpened"
    >
      <div class="detail-toolbar">
        <el-radio-group v-model="detailStatus" size="small" @change="fetchDetail(1)">
          <el-radio-button label="">全部</el-radio-button>
          <el-radio-button label="1">只看成功</el-radio-button>
          <el-radio-button label="0">只看失败</el-radio-button>
        </el-radio-group>
        <el-button size="small" icon="el-icon-download" :disabled="!detailList.length" @click="exportDetail">导出 CSV</el-button>
      </div>

      <el-table
        v-loading="detailLoading"
        :data="detailList"
        height="44vh"
        border
        stripe
        size="small"
        style="width: 100%"
      >
        <el-table-column prop="mem_user" label="会员手机号" min-width="130" />
        <el-table-column prop="crm_id" label="会员ID" width="90" align="center" />
        <el-table-column prop="template_id" label="模板ID" width="80" align="center" />
        <el-table-column prop="coupon_id" label="券实例ID" width="90" align="center">
          <template slot-scope="scope">{{ scope.row.coupon_id || '-' }}</template>
        </el-table-column>
        <el-table-column label="结果" width="80" align="center">
          <template slot-scope="scope">
            <el-tag size="mini" :type="Number(scope.row.status) === 1 ? 'success' : 'danger'">{{ scope.row.status_text }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="reason" label="失败原因" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">{{ scope.row.reason || '-' }}</template>
        </el-table-column>
        <el-table-column prop="create_time" label="时间" width="160" />
      </el-table>

      <el-pagination
        class="pagination"
        small
        @size-change="handleDetailSizeChange"
        @current-change="handleDetailPageChange"
        :current-page="detailPage"
        :page-sizes="[20, 50, 100, 200]"
        :page-size="detailPageSize"
        layout="total, prev, pager, next"
        :total="detailTotal"
        background
      />

      <span slot="footer" class="dialog-footer">
        <el-button @click="detailVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { sendLogs, sendLogDetail } from '@/api/coupon'

export default {
  name: 'CouponLogs',
  data () {
    return {
      loading: false,
      logList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        operator: '',
        status: ''
      },
      dateRange: [],
      // 明细弹窗
      detailVisible: false,
      currentTask: {},
      detailStatus: '',
      detailList: [],
      detailTotal: 0,
      detailPage: 1,
      detailPageSize: 50,
      detailLoading: false
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    taskStatusTagType (status) {
      const map = { 1: 'success', 2: 'warning', 3: 'danger' }
      return map[Number(status)] ?? 'info'
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.operator) params.operator = this.filterForm.operator
        if (this.filterForm.status !== '' && this.filterForm.status !== null) params.status = this.filterForm.status
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_time = this.dateRange[0]
          params.end_time = this.dateRange[1]
        }
        const res = await sendLogs(params)
        if (res && String(res.code) === '0') {
          this.logList = res.data || []
          this.total = res.total || 0
        } else {
          this.logList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取发券任务失败')
        }
      } catch (error) {
        console.error('获取发券任务失败', error)
        this.logList = []
        this.total = 0
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { operator: '', status: '' }
      this.dateRange = []
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    openDetail (row) {
      this.currentTask = row
      this.detailStatus = ''
      this.detailPage = 1
      this.detailList = []
      this.detailTotal = 0
      this.detailVisible = true
    },

    onDetailOpened () {
      this.fetchDetail(1)
    },

    async fetchDetail (page) {
      if (page) this.detailPage = page
      this.detailLoading = true
      try {
        const params = {
          batch_id: this.currentTask.batch_id,
          page: this.detailPage,
          page_size: this.detailPageSize
        }
        if (this.detailStatus !== '') params.status = Number(this.detailStatus)
        const res = await sendLogDetail(params)
        if (res && String(res.code) === '0') {
          this.detailList = res.data || []
          this.detailTotal = res.total || 0
        } else {
          this.detailList = []
          this.detailTotal = 0
          this.$message.error(res && res.msg ? res.msg : '获取发放明细失败')
        }
      } catch (error) {
        console.error('获取发放明细失败', error)
        this.$message.error(error.message || '网络错误，请稍后重试')
      } finally {
        this.detailLoading = false
      }
    },

    handleDetailPageChange (val) {
      this.fetchDetail(val)
    },

    handleDetailSizeChange (val) {
      this.detailPageSize = val
      this.fetchDetail(1)
    },

    exportDetail () {
      const header = ['会员手机号', '会员ID', '模板ID', '券实例ID', '结果', '失败原因', '时间']
      const rows = this.detailList.map(item => [
        item.mem_user,
        item.crm_id,
        item.template_id,
        item.coupon_id || '',
        item.status_text,
        item.reason || '',
        item.create_time
      ])
      const csvContent = '\uFEFF' + [header, ...rows].map(cols => cols.map(v => `"${String(v).replace(/"/g, '""')}"`).join(',')).join('\n')
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `发券明细_${this.currentTask.batch_no}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style lang="scss" scoped>
.coupon-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .pagination {
    margin-top: 16px;
    text-align: right;
  }
}

.detail-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}
</style>
